<ng-container *ngIf="isFocused">
  <div class="gc-cobrowse-box bc-panel">
    <div class="gc-cobrowse-header bc-panel-header">
      <div class="bc-panel-header-text">
        <svg-icon icon="genesys-cobrowse" class="bc-panel-header-icon"></svg-icon>
        <span class="cobrowse-title-text gc-text-bold" translate="gcCobrowse.title"></span>
      </div>
    </div>

    <div class="gc-integration-panel-body">
      <app-genesys-iframe
        #cobrowseFrame
        [iframeUrl]="cobrowseUrl"
        title="Cobrowse"
        [allowList]="fullscreen"
      >
      </app-genesys-iframe>
    </div>
  </div>
</ng-container>
